module.exports = __webpack_public_path__ + "static/img/p_04.9df4fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_04.jpg
// module id = Wrng
// module chunks = 9